import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1a2332] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="text-3xl font-bold mb-4">学習塾NICK</h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              広島県廿日市市大野で中学生の成績アップと志望校合格を全力サポート。少人数指導と集団講義指導のハイブリッドで一人ひとりに寄り添った学習指導を行っています。予約制で完全個別指導やオンライン個別指導も受講できます。
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://lin.ee/Od9tigSF" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-line-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">お問い合わせ</h4>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#4a90e2] mt-1"></i>
                <p className="text-sm">〒739-0400<br />広島県廿日市市大野中央四丁目４－１６</p>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-[#4a90e2]"></i>
                <p className="text-sm">0829-78-1638</p>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-mail-line text-[#4a90e2]"></i>
                <p className="text-sm">rising1001110@gmail.com</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-time-line text-[#4a90e2] mt-1"></i>
                <p className="text-sm">平日 14:00〜22:00<br />土日 14:00〜22:00</p>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">リンク</h4>
            <ul className="space-y-2 text-gray-300">
              <li>
                <Link to="/course" className="text-sm hover:text-[#4a90e2] transition-colors cursor-pointer">
                  コース・料金
                </Link>
              </li>
              <li>
                <Link to="/test" className="text-sm hover:text-[#4a90e2] transition-colors cursor-pointer">
                  定期テスト対策
                </Link>
              </li>
              <li>
                <Link to="/exam" className="text-sm hover:text-[#4a90e2] transition-colors cursor-pointer">
                  高校受験対策
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-[#4a90e2] transition-colors cursor-pointer">
                  塾について
                </Link>
              </li>
              <li>
                <Link to="/access" className="text-sm hover:text-[#4a90e2] transition-colors cursor-pointer">
                  アクセス
                </Link>
              </li>
              <li>
                <Link to="/trial" className="text-sm hover:text-[#4a90e2] transition-colors cursor-pointer">
                  無料体験
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © 2025 学習塾NICK. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-400">
            <a href="#" className="hover:text-white transition-colors cursor-pointer">プライバシーポリシー</a>
            <a href="#" className="hover:text-white transition-colors cursor-pointer">利用規約</a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
